/**
 * Mapeia o código da Natureza da Operação (natOp / invoicy_code) para o código
 * de Exigibilidade do ISS correspondente no padrão ABRASF.
 *
 * IMPORTANTE: Este mapeamento é usado apenas para EXIBIÇÃO no frontend.
 * A resolução real da ExigibilidadeISS no payload enviado à prefeitura é feita
 * no backend (build_json_nfse.py), que consulta o city_code da tabela
 * nfse_nature_operation para o branch específico.
 *
 * Cada município pode ter mapeamentos diferentes (ex: Belém usa códigos em
 * letra como T, H, E). O backend resolve isso automaticamente.
 *
 * @param {string|number} natOpCode - Código InvoiCy da natureza da operação
 * @returns {string} Código da exigibilidade do ISS (para exibição)
 */
export function getExigibilidadeFromNatOp(natOpCode) {
  const code = String(natOpCode);

  const mapping = {
    "1": "1",  // Tributação no Município       → Exigível
    "2": "1",  // Tributação fora do Município   → Exigível
    "3": "3",  // Isenção                        → Isenção
    "4": "5",  // Imune                          → Imunidade
    "5": "6",  // Suspensa (Decisão Judicial)    → Suspensa (Decisão Judicial)
    "6": "7",  // Suspensa (Processo Adm.)       → Suspensa (Processo Adm.)
    "7": "2",  // Não Tributável                 → Não incidência
    "8": "8",  // Fixo                           → Fixo
    "9": "4",  // Exportação                     → Exportação
  };

  return mapping[code] || "1";
}

/**
 * Labels legíveis da Exigibilidade do ISS por código.
 */
export const EXIGIBILIDADE_LABELS = {
  "1": "Exigível (Regra Geral)",
  "2": "Não incidência",
  "3": "Isenção",
  "4": "Exportação",
  "5": "Imunidade",
  "6": "Exigibilidade Suspensa (Decisão Judicial)",
  "7": "Exigibilidade Suspensa (Processo Administrativo)",
  "8": "Fixo",
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/emit/utils/natOpToExigibilidade.js